import { API_URL } from "../lib/constants";
import fetchWithRequestId from "./common";

export const getLeaderboardByPoolId = (accessToken, poolId) => {
  return fetchWithRequestId(
    `${API_URL}/leaderboards/show/${poolId}?friends=true`,
    {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    },
  ).then(async (res) => {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res.json();
  });
};

export const getLeaderboardByPoolIdAll = (accessToken, poolId) => {
  //TODO - change from upper limit of numUsers to all = true/false
  return fetchWithRequestId(
    `${API_URL}/leaderboards/show/${poolId}?numUsers=1000000`,
    {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    },
  ).then(async (res) => {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res.json();
  });
};
